import request from 'utils/request';

const PATH = '/_api/medialib/v1/items';
const AR_PATH = '/_api/medialib-ar/v1/items';

// для теста загрузки видео в dev-режиме
// const PATH = 'http://stage-baza-medialib-upload-private-api.k8s-svc.life-infra.net/api/v1/items';

const Medialib = {
  post: ({ upload, prefix, isAr }) => {
    const body = new FormData();

    if (prefix) {
      body.append('prefix', prefix);
    }

    const uploads = (!(upload instanceof FileList || Array.isArray(upload))) ? [upload] : upload;

    for (let i = 0; i < uploads.length; i += 1) {
      if (uploads[i] instanceof File) {
        body.append('upload', uploads[i]);
      }
    }

    return request(isAr ? AR_PATH : PATH, {
      method: 'POST',
      credentials: 'include',
      body,
    });
  },
};

export default Medialib;
